import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/governance/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/governance/guardrails' });
  },
});
